import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Button } from 'planoplan-ui-kit/core/button';
import { ButtonSelector } from 'planoplan-ui-kit/core/buttonSelector';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { Points } from '@styles';
import { ui } from '@layouts';
import { IS_CLIENT } from '@constants';
import { useTranslations } from '@libs/translations';
import { getOsData } from '@libs';
import { handleClickDownload } from '@modules/helper';
import { OS_MAC_SILICON_EN, OS_MAC_SILICON_RU } from '@constants';

export const Widget = ({ isUser, onLogin, isFixed }) => {
  const { locale } = useSelector((state) => state.settings);
  const translations = useTranslations();
  const [displayLogin, setDisplayLogin] = useState(false);
  const { downloadLink, downloadLinkSecond, os } = getOsData(locale);
  const [key, setKey] = useState('before'); // Ключ нужен что бы заново отрисовать кнопку и убрать навешанные события

  useEffect(() => {
    if (isUser) {
      ui.openUserWidget();
    } else {
      ui.closeUserWidget();
    }
  }, [isUser]);

  useEffect(() => {
    if (IS_CLIENT) {
      /* запасной вариант входа в старый кабинет */
      const url = new URLSearchParams(window.location.search);

      setDisplayLogin(url.has('display-login-button'));
    }

    setKey('after');
  }, []);

  if (!displayLogin) {
    return (
      <View>
        <ProjectButton style={{ display: isFixed ? 'block' : 'none' }}>
          <Button
            key={key}
            theme="primary"
            size={'M'}
            href={downloadLink}
            data-href={downloadLinkSecond}
            onClick={handleClickDownload}>
            {translations.t(`site.navigation.download.${os}`)}
          </Button>
        </ProjectButton>
      </View>
    );
  }

  if (isUser) {
    return (
      <View>
        <div id="user-widget" />
      </View>
    );
  }

  if (!isUser) {
    return (
      <View>
        <ProjectButton style={{ display: isFixed ? 'block' : 'none' }}>
          <Button theme="primary" size={'M'} href={downloadLink} data-href={downloadLinkSecond}>
            {translations.t(`site.navigation.download.${os}`)}
          </Button>
        </ProjectButton>
        <LoginButton style={{ display: isFixed ? 'none' : 'flex' }}>
          <Button
            theme="yellow_black"
            size="M"
            onClick={onLogin}
            device={{ isMobile: deviceDetected.isMobile }}
            widthText>
            {translations.t('site.common.login')}
          </Button>
        </LoginButton>
      </View>
    );
  }
};

const View = styled.div`
  margin-left: auto;
  display: none;

  @media ${Points.laptop} {
    display: block;
  }
`;

const ProjectButton = styled.div`
  width: auto;
  min-width: 190px;
  max-width: 230px;
  display: block;
`;

const LoginButton = styled.div`
  display: flex;

  button {
    min-width: 83px;
  }

  button:first-child {
    margin-right: 6px;
  }
`;
